import script from "./left_img_title.vue?vue&type=script&setup=true&lang=js"
export * from "./left_img_title.vue?vue&type=script&setup=true&lang=js"

import "./left_img_title.vue?vue&type=style&index=0&id=4c6e61a0&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6e61a0"]])

export default __exports__